/**
 * Los diez colores con los que se pinta una etiqueta.
 *
 * Son los unicos hex escritos a mano que no son un estilo: es el DATO que el
 * usuario elige y que se guarda en la base. Un token no sirve —hay que poder
 * guardar el valor— y por eso viven aqui, en un fichero que no pinta nada, en
 * vez de repartidos por el selector.
 */
/* eslint-disable no-restricted-syntax -- la paleta de etiquetas es dato, no estilo: el usuario elige el color y se guarda */
export const PALETTE = [
  { hex: '#EF4444', label: 'Red' },
  { hex: '#F97316', label: 'Orange' },
  { hex: '#F59E0B', label: 'Amber' },
  { hex: '#84CC16', label: 'Lime' },
  { hex: '#10B981', label: 'Emerald' },
  { hex: '#06B6D4', label: 'Cyan' },
  { hex: '#1238c4', label: 'Blue' },
  { hex: '#8B5CF6', label: 'Violet' },
  { hex: '#EC4899', label: 'Pink' },
  { hex: '#6B7280', label: 'Gray' },
]

/** El que se usa cuando una etiqueta no trae color propio. */
export const COLOR_ETIQUETA_POR_DEFECTO = '#3B82F6'
/* eslint-enable no-restricted-syntax */
